let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iGpXg")).then(() => parcelRequire('9YmZU'));